import identifyOptimoveUser from "@casino/client/optimove/identifyUser";
import type FormValues from "@casino/legacy/client/components/Auth/Register/RegisterBody/FormRegister/useFormRegister/FormValues";
import useHandleSportsbetRegister from "@casino/legacy/client/components/Auth/Register/RegisterBody/FormRegister/useFormRegister/useHandleRegister/useHandleSportsbetRegister";
import useRequestEmailVerification from "@casino/legacy/client/components/Auth/Register/RegisterBody/FormRegister/useFormRegister/useHandleRegister/useRequestEmailVerification";
import setDataToGib from "@casino/legacy/client/components/Auth/Shared/utils/setDataToGib";
import useRefCode from "@casino/legacy/client/hooks/cookies/marketing/useRefCode";
import useLanguage from "@casino/legacy/client/hooks/useLanguage";
import useSite from "@casino/legacy/client/hooks/useSite";
import startFraudEngine from "@casino/legacy/client/shared/fraud/fraudEngine";
import authType from "@casino/legacy/shared/utils/auth/authType";
import SessionStorage from "@casino/legacy/shared/utils/storage/SessionStorage";
import FRIENDREF_COOKIE from "@workspace/casino_config/cookies/FRIENDREF_COOKIE";
import REF_AFF from "@workspace/casino_config/cookies/REF_AFF";
import { getCookie, setCookie } from "@workspace/cookies/browser";
import { track } from "@workspace/tracking";
import useSocialAuthLocale from "../../SocialAuth/hooks/useSocialAuthLocale";
import useUpdateUserLanguage from "../../SocialAuth/hooks/useUpdateUserLanguage";
import useHandleAuthenticate from "./useHandleAuthenitcate";

const CONNECTION_TO_METHOD: Partial<Record<Connection, string>> = {
  "google-oauth2": "Google",
  telegram: "Telegram",
  line: "Line",
  twitter: "X",
  facebook: "Facebook",
  apple: "Apple",
};

const useHandleCompleteRegistration = () => {
  const { requestEmailVerification } = useRequestEmailVerification();
  const { site, isBridgeSite } = useSite();
  const { code: language } = useLanguage();
  const refCode = useRefCode();
  const refAff = getCookie(REF_AFF);
  const friendRef = getCookie(FRIENDREF_COOKIE);
  const cid = getCookie("cid");
  const accessToken = SessionStorage?.getItem("social_auth_token") as string;
  const updateUserLanguage = useUpdateUserLanguage();
  const socialAuthType = getCookie("social_auth_type");

  const { handleSportsbetRegister } = useHandleSportsbetRegister();
  const [, , clearSocialAuthLocale] = useSocialAuthLocale();
  const { handleAuthenticate, loading } = useHandleAuthenticate();

  const handleCompleteRegistration = async (
    values: Omit<FormValues, "dateOfBirth"> & { dateOfBirth: number },
  ) => {
    const { username, email, dateOfBirth, offers, phone } = values;

    const variables = {
      username,
      email,
      dateOfBirth,
      phone,
      offers,
      site,
      language,
      domain: window.location.hostname,
      refCode,
      refAff,
      cid,
      friendRef,
    };

    const {
      token = "",
      deviceDataToken = "",
      errors,
      sessionId,
      userManagement,
    } = await handleAuthenticate(variables, accessToken);

    if (errors) {
      return { errors };
    }

    setCookie("token", token);
    startFraudEngine({ deviceDataToken });
    track("Registration", {
      userId: userManagement?.profile?._id,
      captchaVersion: "none",
      method:
        CONNECTION_TO_METHOD[socialAuthType as Connection] ??
        socialAuthType ??
        "Unknown",
      offers: offers ?? false,
    });
    await updateUserLanguage(language);
    requestEmailVerification();

    if (userManagement?.profile?._id && sessionId) {
      setDataToGib(userManagement?.profile?._id, sessionId);
    }
    const optimoveUserId = userManagement?.profile?._id;
    if (optimoveUserId) {
      identifyOptimoveUser(optimoveUserId);
    }

    authType.remove();
    SessionStorage.removeItem("social_auth_missing_fields");
    SessionStorage.removeItem("social_auth_token");
    clearSocialAuthLocale();

    if (isBridgeSite) {
      handleSportsbetRegister();
    }

    return {};
  };
  return {
    loading,
    handleCompleteRegistration,
  };
};

export default useHandleCompleteRegistration;
